import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../components/button/Button";
import DisplayContainer from "../../../../components/displayContainer/DisplayContainer";
import AuthTextInput from "../../../../components/inputs/authTextInput/AuthTextInput";
import SelectInput from "../../../../components/inputs/selectInput/SelectInput";
import Loader from "../../../../components/loader/Loader";
import TextWrapper from "../../../../components/textWrapper/TextWrapper";
import { roles } from "../../../../constants/roles";
import { fetchAdmins } from "../../../../features/admins/adminsSlice";
import { showConfirmationModal } from "../../../../features/confirmationModal/ConfirmationModalSlice";
import styles from "./addNewEmployee.module.css";

const AddNewEmployee = () => {
  const [adminName, setAdminName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfrimPassword] = useState("");
  const [role, setRole] = useState("");

  const [adminNameEligibility, setAdminNameEligibility] = useState(false);
  const [passwordEligibility, setPasswordEligibility] = useState(false);

  const { addStatus: adminStatus } = useSelector((state) => state.admins);

  const { list: admins, fetchStatus } = useSelector((state) => state.admins);
  const { userId } = useSelector((state) => state.user);

  const currentAdmin = admins.find((item) => item._id === userId);
  const manageableRoles = Array.isArray(roles[currentAdmin?.role?.role]?.canManage)
    ? roles[currentAdmin.role.role].canManage
    : [];

  const dispatch = useDispatch();

  useEffect(() => {
    if (fetchStatus === "idle") {
      dispatch(fetchAdmins());
    }
  }, [dispatch, fetchStatus]);

  useEffect(() => {
    if (adminStatus === "succeeded") {
      setAdminName("");
      setPassword("");
      setConfrimPassword("");
      setRole("");
      setAdminNameEligibility(false);
      setPasswordEligibility(false);
    }
  }, [adminStatus]);

  const handleSubmit = () => {
    if (
      adminNameEligibility &&
      passwordEligibility &&
      password === confirmPassword
    ) {
      dispatch(
        showConfirmationModal({
          message: "هل انت متاكد من انشاء الموظف ؟",
          data: { name: adminName, password, role },
          actionType: "createAdmin",
        })
      );
      if (adminStatus === "idle") {
        setAdminName("");
        setPassword("");
        setConfrimPassword("");
        setRole("");
        setAdminNameEligibility(false);
        setPasswordEligibility(false);
      }
    }
  };

  if (adminStatus === "loading") {
    return (
      <div className={styles.loaderContainer}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <TextWrapper textStyle="textTitle">اضافة موظف جديد</TextWrapper>
      </div>
      <div className={styles.addNewEmployeeWrapper}>
        <DisplayContainer className={styles.formPanel}>
          <div className={styles.inputWrapper}>
            <div className={styles.fieldLabel}>
              <TextWrapper textStyle="textMid">اسم الموظف</TextWrapper>
            </div>
            <AuthTextInput
              height="50px"
              width="100%"
              borderRadius="10px"
              placeholder="اسم الموظف"
              bgColor={"grey"}
              regex={/^.{5,}$/}
              value={adminName}
              setValue={setAdminName}
              setEligibility={setAdminNameEligibility}
            />
          </div>
          <div className={styles.inputWrapper}>
            <div className={styles.fieldLabel}>
              <TextWrapper textStyle="textMid">كلمة السر</TextWrapper>
            </div>
            <AuthTextInput
              height="50px"
              width="100%"
              borderRadius="10px"
              placeholder="كلمة السر"
              bgColor={"grey"}
              regex={/^.{8,}$/}
              value={password}
              setValue={setPassword}
              setEligibility={setPasswordEligibility}
              isPassword={true}
            />
          </div>
          <div className={styles.inputWrapper}>
            <div className={styles.fieldLabel}>
              <TextWrapper textStyle="textMid">تأكيد كلمة السر</TextWrapper>
            </div>
            <AuthTextInput
              height="50px"
              width="100%"
              borderRadius="10px"
              placeholder="تأكيد كلمة السر"
              bgColor={"grey"}
              value={confirmPassword}
              setValue={setConfrimPassword}
              isPassword={true}
            />
          </div>
          <div className={styles.inputWrapper}>
            <div className={styles.fieldLabel}>
              <TextWrapper textStyle="textMid">اختيار الوظيفه</TextWrapper>
            </div>
            <SelectInput
              setValue={setRole}
              value={role}
              placeHolder={"اختيار الوظيفه"}
              className={styles.selectInput}
            >
              {manageableRoles.map((item, index) => (
                <option value={item} key={index}>
                  {item}
                </option>
              ))}
            </SelectInput>
          </div>
          <div className={styles.createNewAdminBtnWrapper}>
            <Button
              size="bigSize"
              variant="blackVariant"
              functionallity={handleSubmit}
            >
              <TextWrapper textStyle="textMid">تسجيل الموظف الجديد</TextWrapper>
            </Button>
          </div>
        </DisplayContainer>
      </div>
    </div>
  );
};

export default AddNewEmployee;
